import policyData from "./policy";

const policyList = [policyData];
export default policyList;
